export default __webpack_public_path__ + "static/media/member-walkin.95e2e1d9.svg";